import React from "react";

import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {
  MdmObject,
  useCreateObjectMutation
} from "gql/generated/types";
import { useNavigate, useOutletContext } from "react-router-dom";
import ObjectForm from "../components/ObjectForm";

const NewObjectForm = () => {
  const navigate = useNavigate();
  const projectId = useOutletContext<string>();
  const [mutateFunction] = useCreateObjectMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Object updated successfully",
        life: 3000,
      });
      navigate("/");
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
    refetchQueries: ["GetObjectsByProject"],
  });
 
  
  const handleCreate = (object: Partial<MdmObject>) => {
    mutateFunction({
      variables: { object: { ...object, projectId } },
    });
  };
  return <ObjectForm object={null} onSubmit={handleCreate} />;
};

export default NewObjectForm;
